export enum Constants {
  TRACK = '@@analytics/TRACK',
}
